import { ICategoryDto } from "@crunchit/types";
import useTranslationText from "hooks/useTranslationText";
import "./CategoryGrid.scss";

interface ICategoryGridProps {
  categories: ICategoryDto[];
  handleCategoryClick: (categoryId: number) => void;
}

export default function CategoryGrid(props: ICategoryGridProps) {
  const { categories } = props;
  const { handleCategoryClick } = props;

  const { getTranslationText } = useTranslationText();

  return (
    <div className="category-grid">
      {categories.map(function (category) {
        const backgroundImage = category.imageUrl ? `url(${category.imageUrl})` : "";

        return (
          <article key={category.id} className="gridbox" onClick={() => handleCategoryClick(category.id)}>
            <div className="gridbox-image" style={{ backgroundImage }}></div>
            <h1 className="gridbox-title">{getTranslationText(category.name)}</h1>
          </article>
        );
      })}
    </div>
  );
}
